import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketBestBuyComponent } from './market-best-buy.component';
import { StepBestBuySectionComponent } from './step-best-buy-section/step-best-buy-section.component';
import { ProductsBestBuyComponent } from './products-best-buy/products-best-buy.component';
import { MostPopularProductsComponent } from './most-popular-products/most-popular-products.component';
import {RouterModule, Routes} from '@angular/router';
import {SharedModule} from '@app/marketplace/shared/shared.module';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';

const routes: Routes = [
  { path: '', component: MarketBestBuyComponent },
];

@NgModule({
  declarations: [
    MarketBestBuyComponent,
    StepBestBuySectionComponent,
    ProductsBestBuyComponent,
    MostPopularProductsComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    NgxSkeletonLoaderModule,
    NgbTooltipModule
  ]
})
export class MarketBestBuyModule { }
